import script from "./editAddressInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./editAddressInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./editAddressInfoModal.vue?vue&type=style&index=0&id=43e4a448&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e4a448"]])

export default __exports__